import UserAgentdetector from '../modules/Detector';

export default function useDetector() {
    return new UserAgentdetector(navigator.userAgent);
}
